// 本地存储管理工具
class StorageManager {
  constructor() {
    this.STORAGE_KEYS = {
      USERS: 'blog_users',
      POSTS: 'blog_posts',
      CURRENT_USER: 'blog_current_user',
      SETTINGS: 'blog_settings'
    };
    this.init();
  }

  // 初始化默认数据
  init() {
    // 初始化默认用户
    if (!localStorage.getItem(this.STORAGE_KEYS.USERS)) {
      const defaultUsers = [
        {
          id: 'user_1',
          username: 'admin',
          email: 'admin@example.com',
          password: 'admin123', // 实际项目中应该加密
          avatar: 'https://api.dicebear.com/7.x/avataaars/svg?seed=admin',
          bio: '博客管理员，热爱技术和写作。',
          createdAt: new Date().toISOString()
        }
      ];
      localStorage.setItem(this.STORAGE_KEYS.USERS, JSON.stringify(defaultUsers));
    }

    // 初始化示例文章
    if (!localStorage.getItem(this.STORAGE_KEYS.POSTS)) {
      const defaultPosts = [
        {
          id: 'post_1',
          title: '欢迎来到React博客系统',
          content: `# 欢迎使用React19博客系统

这是一个基于React 19构建的现代化博客系统，支持Markdown编辑和本地存储。

## 功能特性

- 📝 支持Markdown编辑和渲染
- 👤 用户注册和登录
- 📱 响应式设计
- 🎨 现代简约的UI设计

## 开始使用

1. 注册一个新账户
2. 开始撰写你的第一篇文章
3. 使用Markdown语法格式化你的内容

### 代码示例

\`\`\`javascript
function welcome() {
  console.log('欢迎使用React博客！');
}
\`\`\`

### 列表示例

- 项目一
- 项目二
- 项目三

> 这是一个引用示例

**加粗文本** 和 *斜体文本*

[链接示例](https://example.com)

![图片示例](https://picsum.photos/400/200)`,
          author: 'user_1',
          tags: ['React', 'JavaScript', '博客'],
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString(),
          views: 42,
          likes: 15
        },
        {
          id: 'post_2',
          title: 'Markdown语法指南',
          content: `# Markdown语法指南

## 标题

# H1 标题
## H2 标题
### H3 标题

## 文本格式

**加粗文本**
*斜体文本*
~~删除线文本~~

## 列表

### 无序列表
- 项目1
- 项目2
  - 子项目
  - 子项目

### 有序列表
1. 第一步
2. 第二步
3. 第三步

## 链接和图片

[链接文本](https://example.com)
![图片描述](https://picsum.photos/300/200)

## 代码

行内代码：\`console.log('hello')\`

代码块：
\`\`\`javascript
function example() {
  return 'Hello, World!';
}
\`\`\`

## 表格

| 列1 | 列2 | 列3 |
|-----|-----|-----|
| 内容1 | 内容2 | 内容3 |
| 内容4 | 内容5 | 内容6 |

## 引用

> 这是一个引用
> 可以有多行

## 分隔线

---

## 任务列表

- [x] 完成任务
- [ ] 待办事项`,
          author: 'user_1',
          tags: ['Markdown', '教程'],
          createdAt: new Date(Date.now() - 86400000).toISOString(), // 前一天
          updatedAt: new Date(Date.now() - 86400000).toISOString(),
          views: 28,
          likes: 8
        }
      ];
      localStorage.setItem(this.STORAGE_KEYS.POSTS, JSON.stringify(defaultPosts));
    }
  }

  // 获取数据
  get(key) {
    try {
      const data = localStorage.getItem(key);
      return data ? JSON.parse(data) : null;
    } catch (error) {
      console.error('Error getting data from localStorage:', error);
      return null;
    }
  }

  // 设置数据
  set(key, value) {
    try {
      localStorage.setItem(key, JSON.stringify(value));
      return true;
    } catch (error) {
      console.error('Error setting data to localStorage:', error);
      return false;
    }
  }

  // 删除数据
  remove(key) {
    try {
      localStorage.removeItem(key);
      return true;
    } catch (error) {
      console.error('Error removing data from localStorage:', error);
      return false;
    }
  }

  // 清空所有数据
  clear() {
    try {
      Object.values(this.STORAGE_KEYS).forEach(key => {
        localStorage.removeItem(key);
      });
      this.init(); // 重新初始化默认数据
      return true;
    } catch (error) {
      console.error('Error clearing localStorage:', error);
      return false;
    }
  }

  // 用户相关操作
  getUsers() {
    return this.get(this.STORAGE_KEYS.USERS) || [];
  }

  saveUsers(users) {
    return this.set(this.STORAGE_KEYS.USERS, users);
  }

  // 文章相关操作
  getPosts() {
    return this.get(this.STORAGE_KEYS.POSTS) || [];
  }

  savePosts(posts) {
    return this.set(this.STORAGE_KEYS.POSTS, posts);
  }

  // 当前用户
  getCurrentUser() {
    return this.get(this.STORAGE_KEYS.CURRENT_USER);
  }

  setCurrentUser(user) {
    return this.set(this.STORAGE_KEYS.CURRENT_USER, user);
  }

  clearCurrentUser() {
    return this.remove(this.STORAGE_KEYS.CURRENT_USER);
  }

  // 设置相关
  getSettings() {
    return this.get(this.STORAGE_KEYS.SETTINGS) || {
      theme: 'light',
      language: 'zh-CN'
    };
  }

  saveSettings(settings) {
    return this.set(this.STORAGE_KEYS.SETTINGS, settings);
  }
}

// 创建单例实例
const storage = new StorageManager();

export default storage;